import { useEffect } from 'react';
import { toast } from 'react-toastify';

const CHECK_INTERVAL_MS = 5 * 60 * 1000;
export const NEW_VERSION_TOAST_ID = 'new-app-version';

// A tab left open keeps running the bundle it loaded. Every deploy writes its id to /version.json
// (see Dockerfile), so compare it with the id this bundle was built with and offer a reload.
// The reload is the user's call: forcing it would throw away a half-filled form.
export const useNewVersionCheck = () => {
  useEffect(() => {
    const currentBuildId = process.env.REACT_APP_BUILD_ID;
    // Not a deployed build (npm start, tests)
    if (!currentBuildId) return undefined;

    const check = async () => {
      if (document.visibilityState === 'hidden' || toast.isActive(NEW_VERSION_TOAST_ID)) return;
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/version.json`, { cache: 'no-store' });
        if (!response.ok) return;
        const { buildId } = await response.json();
        if (buildId && buildId !== currentBuildId) {
          toast.info('A new version of the app is available. Click here to reload the page.', {
            toastId: NEW_VERSION_TOAST_ID,
            autoClose: false,
            onClick: () => window.location.reload(),
          });
        }
      } catch {
        // Offline or mid-deploy: the next check tries again
      }
    };

    const interval = setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', check);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', check);
    };
  }, []);
};
